import _ from "lodash";
import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import IntlMessages from "util/intlMessages";
import Select from "react-select";

const ZodiacSelector = (props) => {
  const { signs } = props.envStore;
  const { name = "astroSign", setValue } = props;

  const options = () =>
    _.map(signs, (value) => {
      return { value, label: <IntlMessages id={`AstroSigns.${value}`} /> };
    });

  const onChangeHandler = (selectedOptions) => {
    const value = selectedOptions.value;
    const target = { name, value };
    setValue({ target });
  };

  return (
    <Select
      isMulti={false}
      name={name}
      value={
        props.value
          ? { value: props.value, label: <IntlMessages id={`AstroSigns.${props.value}`} /> }
          : null
      }
      options={options()}
      placeholder={<IntlMessages id="AstroSigns" />}
      onChange={onChangeHandler}
    />
  );
};

const mapStateToProps = (state) => ({
  envStore: state.api.env,
});

export default connect(mapStateToProps, {})(ZodiacSelector);
